const TagIconSVG = ({ className = "" }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clip-path="url(#clip0_4321_10847)">
        <path
          d="M10.7377 2.90496C10.4252 2.59238 10.0013 2.41672 9.55935 2.41663H3.58268C3.14065 2.41663 2.71673 2.59222 2.40417 2.90478C2.09161 3.21734 1.91602 3.64127 1.91602 4.08329V10.06C1.91611 10.502 2.09177 10.9258 2.40435 11.2383L9.65768 18.4916C10.0364 18.868 10.5487 19.0792 11.0827 19.0792C11.6166 19.0792 12.1289 18.868 12.5077 18.4916L17.991 13.0083C18.3674 12.6295 18.5786 12.1173 18.5786 11.5833C18.5786 11.0493 18.3674 10.5371 17.991 10.1583L10.7377 2.90496Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.25781 9.20642C8.08624 9.20642 8.75781 8.53485 8.75781 7.70642C8.75781 6.87799 8.08624 6.20642 7.25781 6.20642C6.42939 6.20642 5.75781 6.87799 5.75781 7.70642C5.75781 8.53485 6.42939 9.20642 7.25781 9.20642Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4321_10847">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.25 0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TagIconSVG;
